'use strict';

const stylitics = window.resources.stylitics;

/**
 * Initializes Stylitics widget
 */
function init() {
    const $widgetContainer = $('#stylitics-widget-container');
    const $widgetAccordion = $widgetContainer.closest('.accordion__section');
    const $widgetAccordionContent = $widgetContainer.closest('.accordion__body');
    const jumpLinkSelector = '.js-stylitics-jumplink';
    let lastItemNumberWithResults;

    if (typeof StyliticsHotspotsWidget === 'undefined') {
        $widgetAccordion.hide();
        console.error('StyliticsHotspotsWidget is undefined. Stylitics functionality has been disabled.');
        return;
    }

    if (!stylitics.user) {
        $widgetAccordion.hide();
        console.error('styliticsAccountUser is undefined. Stylitics functionality has been disabled.');
        return;
    }

    /**
     * Get item number from concatenated dtm productMasterProductID and productColorCode
     * @returns {string} The item number
     */
    function getItemNumber() {
        const dtmProductInfo = (window.digitalData
            && window.digitalData.page
            && window.digitalData.page.product
            && window.digitalData.page.product.productInfo) || {};

        if (dtmProductInfo.productMasterProductID && dtmProductInfo.productColorCode) {
            return dtmProductInfo.productMasterProductID + dtmProductInfo.productColorCode;
        }

        return '';
    }

    const widgetInstance = new StyliticsHotspotsWidget(stylitics.user, 'stylitics-widget-container', { // eslint-disable-line no-undef
        api: {
            item_number: getItemNumber(),
            max: 6,
            min: 3
        },
        display: {
            disableMnM: false
        },
        customer: {
            locale: stylitics.locale
        },
        text: {
            viewDetailsCTA: stylitics.shopCta,
            seeMoreOptionsCTA: stylitics.seeMoreText,
            mnmClose: stylitics.closeText,
            itemDetailsModalHeader: stylitics.productListText,
            itemLinkCTA: stylitics.shopText
        }
    });

    widgetInstance.on('mount', 'bundles', function (data) {
        const hasResults = !!(data.bundles && data.bundles.length);

        lastItemNumberWithResults = hasResults ? getItemNumber() : lastItemNumberWithResults;

        $(jumpLinkSelector).toggleClass('d-flex', hasResults);
        $widgetAccordion.toggle(hasResults);
    });

    widgetInstance.on('mount', 'bundle', function (data) {
        if (data.bundle['on-model-image'] && stylitics.shopTheLookImage) {
            let badge = document.createElement('img');
            badge.setAttribute('src', stylitics.shopTheLookImage);
            badge.setAttribute('alt', 'This outfit corresponds with model\'s on product image');
            data.element.querySelector('.stylitics-bundle-badge').appendChild(badge);
        }
    });

    $('body').on('product:afterImageGalleryUpdate', function () {
        // Hovering over a swatch rebuilds the gallery with the jumplink hidden by default
        // We must unhide the jumplink if it was previously shown
        const itemNumber = getItemNumber();

        if (itemNumber === lastItemNumberWithResults) {
            $(jumpLinkSelector).toggleClass('d-flex', true);
        }
    });

    $('body').on('product:afterAttributeSelect', function () {
        const itemNumber = getItemNumber();

        if (itemNumber) {
            widgetInstance.refresh({ api: { item_number: itemNumber } });
        } else {
            $(jumpLinkSelector).toggleClass('d-flex', false);
            $widgetAccordion.hide();
        }
    });

    $('body').on('click', jumpLinkSelector, function () {
        $widgetAccordionContent.addClass('show');
        $widgetAccordion.scrollTo($('.navbar-header').outerHeight(), 750);
    });

    widgetInstance.start();
}

/**
 * Loads the Stylitics library and initializes Stylitics widget
 * @param {string} libUrl the URL of the Stylitics library
 */
function loadStyliticsLib(libUrl) {
    const scriptElement = document.createElement('script');

    scriptElement.setAttribute('src', libUrl);
    scriptElement.setAttribute('type', 'text/javascript');
    scriptElement.setAttribute('async', 'true');

    document.body.appendChild(scriptElement);

    // success event
    scriptElement.addEventListener('load', function () {
        init();
    });

    // error event
    scriptElement.addEventListener('error', function (e) {
        console.error('Error loading Stylitics library, attempted loading: ' + libUrl, e);
    });
}

loadStyliticsLib(stylitics.script);
